var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eSystem-page01",
    transform: "translate(-360.000000, -672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/vorteile",
    transform: "translate(361.000000, 673.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4499,45.93075 C84.3299,45.72075 82.1599,42.67575 78.1299,43.54075 C73.5499,44.51575 64.9349,49.10075 63.3849,50.01575 C63.0449,49.22575 62.5599,48.43575 61.8449,47.76075 C60.2549,46.25575 57.9849,46.56575 55.0999,46.94575 C50.2199,47.58575 45.0449,47.31575 44.8149,47.25075 C43.9499,46.72575 40.1049,42.51575 33.2449,43.80575 C28.8149,44.63575 25.6199,45.23075 24.0399,46.47575 L23.9199,63.95575 C28.0049,64.52575 46.3599,64.89075 54.9499,63.75575 C56.3749,63.57075 57.5499,63.28575 58.3549,62.87575 C64.1399,59.97575 83.2649,47.96075 84.0799,47.45075 L85.0049,46.87075 L84.4499,45.93075 Z",
    id: "Stroke-1",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0251,42.6958 L15.7701,42.6357596 C15.2051,42.6308 14.7351,43.0908 14.7351,43.6608 L14.5800596,66.8908 C14.5751,67.4558 15.0351,67.9208 15.6051,67.9208 L22.8551,67.9858408 C23.4201,67.9908 23.8901,67.5358 23.8951,66.9658 L24.0501,43.7358 C24.0501,43.1708 23.5901,42.7008 23.0251,42.6958 Z",
    id: "Stroke-3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "63.3813 50.01645 64.2693 52.62895 43.7418 55.74045"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.4465,
    y1: 46.1832,
    x2: 0,
    y2: 46.1832,
    id: "Stroke-11",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.4465,
    y1: 63.85925,
    x2: 0,
    y2: 63.85925,
    id: "Stroke-13",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(45.004900, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9822637,0.227240096 C15.4419906,-0.0757466987 14.5580094,-0.0757466987 14.0178968,0.227240096 L0.98218345,7.53741995 C0.442070806,7.84040674 0,8.58400242 0,9.18982015 L0,23.8101798 C0,24.4161534 0.442070806,25.1597491 0.98218345,25.4625801 L14.0178968,32.7727599 C14.5580094,33.0757467 15.4419906,33.0757467 15.9822637,32.7727599 L29.0178165,25.4625801 C29.5580897,25.1597491 30,24.4161534 30,23.8101798 L30,9.18982015 C30,8.58400242 29.5580897,7.84040674 29.0178165,7.53741995 L15.9822637,0.227240096 Z",
    id: "hexagon-cta-red-background",
    stroke: "#00ADEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00ADEF",
    x: 5.9951,
    y: 16,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#00ADEF",
    x: 13.9951,
    y: 8,
    width: 2,
    height: 18
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.03f281d17aa1e826fb7c23a63bd5b3d1.svg";
export { ForwardRef as ReactComponent };